import apiClient from "../../utils/clients/axios";

const BASE = `/api/quality_control/production_variation`;

// field names of the production report, offered when adding a limit
export const getVariationFields = async () => {
  const response = await apiClient.get(`${BASE}/fields`);
  return response?.data || [];
};

export const getVariationLimits = async () => {
  const response = await apiClient.get(`${BASE}/limits`);
  return response?.data || [];
};

// payload: { field, minValue, maxValue, isActive }
export const createVariationLimit = async (payload) => {
  const response = await apiClient.post(`${BASE}/limits`, payload);
  return response?.data;
};

// payload: any of { field, minValue, maxValue, isActive }
export const updateVariationLimit = async ({ id, payload }) => {
  const response = await apiClient.put(`${BASE}/limits/${id}`, payload);
  return response?.data;
};

export const deleteVariationLimit = async (id) => {
  const response = await apiClient.delete(`${BASE}/limits/${id}`);
  return response?.data;
};

// logins that can raise / be assigned the tickets
export const getVariationUsers = async () => {
  const response = await apiClient.get(`${BASE}/users`);
  return response?.data || [];
};

export const getVariationSettings = async () => {
  const response = await apiClient.get(`${BASE}/settings`);
  return response?.data;
};

// payload: { reportedByUserId, managerUserIds }
export const updateVariationSettings = async (payload) => {
  const response = await apiClient.put(`${BASE}/settings`, payload);
  return response?.data;
};

// automatic shift-end tickets on / off
export const updateVariationEnabled = async (enabled) => {
  const response = await apiClient.put(`${BASE}/settings/enabled`, { enabled });
  return response?.data;
};

// tickets raised by the check; params: { from, to, status, page, pageSize }
export const getVariationTickets = async (params) => {
  const response = await apiClient.get(`${BASE}/tickets`, { params });
  return response?.data || { rows: [], total: 0 };
};

// dry run for one shift: what the check would raise, creates nothing;
// payload: { date, shift }
export const previewVariationCheck = async (payload) => {
  const response = await apiClient.post(`${BASE}/preview`, payload);
  return response?.data;
};

// runs the check for one shift now; payload: { date, shift }
export const runVariationCheck = async (payload) => {
  const response = await apiClient.post(`${BASE}/run`, payload);
  return response?.data;
};
